import React, { useCallback, useState } from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';

import { RepoUrlPickerState } from '../../interfaces/RepoUrlPickerState';

interface ProjectPickerProps {
  projects: string[] | undefined;
  project?: string;
  onChange: (state: RepoUrlPickerState) => void;
  rawErrors: string[];
}

export default function ProjectPicker(
  props: Readonly<ProjectPickerProps>,
): JSX.Element {
  const { projects, project, onChange, rawErrors } = props;
  const [currentSelection, setCurrentSelection] = useState<string | undefined>(
    project,
  );

  const handleOnChange = useCallback((e: any, value: any) => {
    onChange({
      project: value,
    });
    setCurrentSelection(value);
  }, []);

  return (
    <FormControl
      margin="normal"
      required
      error={rawErrors?.length > 0 && !project}
      disabled={projects?.length === 1}
    >
      <Autocomplete
        getOptionLabel={option => option}
        onChange={handleOnChange}
        options={projects ?? []}
        value={currentSelection}
        renderInput={params => (
          <TextField {...params} label="Azure DevOps Project *" />
        )}
        data-testid="azure-devops-project-select"
      />

      <FormHelperText>Choose an Azure DevOps Project</FormHelperText>
    </FormControl>
  );
}
